import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type StoryItem = paths['/v3/story/{type}/{slug}/'];

const getStoryItem = createRequest<StoryItem>('/pc/v3/story/{type}/{slug}/');

export default getStoryItem;
